module.exports = __webpack_public_path__ + "static/media/ic_ticket_board_blue.0a42ca89.svg";